import { Button } from "@newsela/angelou";
import PropTypes from "prop-types";

import { withTrackEvent } from "@newsela/snitch";

import { buttonItemCss } from "./ActionsDropdownButtonItem.style";

const ButtonWithTrackEvent = withTrackEvent(Button);

const ActionsDropdownButtonItemPropTypes = {
  children: PropTypes.node,
  __cssFor: PropTypes.object,
  ariaProps: PropTypes.object,
  dataProps: PropTypes.object,
  eventProperties: PropTypes.object,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
};

const ActionsDropdownButtonItem = ({
  children,
  __cssFor,
  ariaProps,
  dataProps,
  eventProperties,
  isSelected,
  onClick,
}) => {
  return (
    <li>
      <ButtonWithTrackEvent
        __cssFor={{
          ...__cssFor?.Button,
          root: [buttonItemCss(isSelected), __cssFor?.Button?.root],
        }}
        ariaProps={ariaProps}
        dataProps={dataProps}
        flavor={Button.flavors.polarTertiary}
        size={Button.sizes.md}
        onClick={onClick}
        {...eventProperties}
      >
        {children}
      </ButtonWithTrackEvent>
    </li>
  );
};

ActionsDropdownButtonItem.propTypes = ActionsDropdownButtonItemPropTypes;

export default ActionsDropdownButtonItem;
